/**
 * Normalises a text override before it reaches the render script.
 *
 * Shared by the preview and the download mapper: a value carrying <br> or CRLF has to become the
 * same thing on both paths, or a multi-line variable renders differently in the editor than it
 * does in the export.
 */
export function normalizeInDesignTextOverrideValue(value?: string) {
    if (typeof value !== "string") {
        return value;
    }

    return value
        .replace(/\r\n?/g, "\n")
        .replace(/\s*<br\s*\/?>\s*/gi, "\n")
        .replace(/[ \t]+\n/g, "\n")
        .replace(/\n[ \t]+/g, "\n");
}
